module.exports = __webpack_public_path__ + "static/media/buy_req_rent_14.b39a99e5.png";